export const glyphIconStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '.arrow-button.enabled': {
    fontFamily: iconFontFamily,
    color: palette.themePrimary,
    cursor: 'pointer',
  },

  '.arrow-button.enabled:before': {
    content: '"\\E710"',
  },

  '.arrow-button.remove': {
    fontFamily: iconFontFamily,
    color: palette.themePrimary,
    cursor: 'pointer',
  },

  '.arrow-button.remove:before': {
    content: '"\\E738"',
  },

  '.infomark': {
    fontFamily: iconFontFamily,
    fontSize: 14,
    marginRight: 5,
    color: '#606060',
    verticalAlign: 'middle',
    display: 'inline-block',
  },

  '.infomark:before': {
    content: '"\\E783"',
  },

  '.expanderImage, .expandedImage': {
    color: palette.themePrimary,
  },

  '.expanderImage:before': {
    fontFamily: iconFontFamily,
    content: '"\\E76C"',
  },

  '.expandedImage:before': {
    fontFamily: iconFontFamily,
    content: '"\\E70D"',
  },

  '.glyphicon-remove': {
    fontFamily: iconFontFamily,
    color: palette.themePrimary,
  },

  '.glyphicon-remove:before': {
    content: '"\\E711"',
  },

  '.glyphicon-triangle-right': {
    fontFamily: iconFontFamily,
    color: palette.neutralPrimary,
  },

  '.glyphicon-triangle-right:before': {
    content: '"\\F08F"',
  },

  '.glyphicon-triangle-bottom': {
    fontFamily: iconFontFamily,
    color: palette.neutralPrimary,
  },

  '.glyphicon-triangle-bottom:before': {
    content: '"\\F08E"',
  },

  '.glyphicon-plus': {
    fontFamily: iconFontFamily,
    color: palette.themePrimary,
  },

  '.glyphicon-plus:before': {
    content: '"\\E710"',
  },

  'input[type="checkbox"]': {
    fontFamily: iconFontFamily,
    appearance: 'none',
    '-webkit-appearance': 'none',
  },

  'input[type="checkbox"]::after': {
    content: '"\\E73E"',
  },

  'input[type="radio"]': {
    outline: 'none !important',
  },

  '.glyphicon-arrow-down, .glyphicon-arrow-up': {
    fontFamily: iconFontFamily,
    color: palette.neutralPrimary,
  },

  '.glyphicon-arrow-down:before': {
    content: '"\\E74B"',
  },

  '.glyphicon-arrow-up:before': {
    content: '"\\E74A"',
  },

  '.map-icon__pin--included': {
    fontFamily: iconFontFamily,
    color: '#107C10',
  },

  '.map-icon__pin--included:before': {
    content: '"\\F5CA"',
  },

  '.map-icon__pin--excluded': {
    fontFamily: iconFontFamily,
    color: '#A80000',
  },

  '.map-icon__pin--excluded:before': {
    content: '"\\F5CD"',
  },

  '.status_icon': {
    fontFamily: iconFontFamily,
  },

  '.status_icon:before': {
    content: '"\\E712"',
  },

  '.insight_icon': {
    fontFamily: iconFontFamily,
  },

  '.insight_icon:before': {
    content: '"\\E3AF"',
  },

  '.glyph-caret-right::before': {
    fontFamily: iconFontFamily,
    content: '"\\E974"',
  },
  '.glyph-caret-left::before': {
    fontFamily: iconFontFamily,
    content: '"\\E973"',
  },
  '.closeimage': {
    fontFamily: iconFontFamily,
    fontSize: 14,
    color: palette.neutralSecondary,
  },

  '.closeimage:before': {
    content: '"\\E711"',
  },

  '.glyphicon-pencil, .edit_icon': {
    fontFamily: iconFontFamily,
    fontStyle: 'normal',
  },

  '.glyphicon-pencil::before, .edit_icon::before': {
    content: '"\\E70F"',
    color: palette.themePrimary,
  },
  '.grid-asc::before': {
    fontFamily: iconFontFamily,
    content: '"\\EE68"',
  },
  '.grid-des::before': {
    fontFamily: iconFontFamily,
    content: '"\\EE69"',
  },

  '.glyphicon-chevron-down:before': {
    fontFamily: iconFontFamily,
    content: '"\\E70D"',
  },
  '.glyphicon-chevron-up:before': {
    fontFamily: iconFontFamily,
    content: '"\\E70E"',
  },

  '.recommendation-light-bulb:before': {
    fontFamily: iconFontFamily,
    content: '"\\EA80"',
  },
  '.status_error:before': {
    fontFamily: iconFontFamily,
    content: '"\\E946"',
    color: palette.redDark,
  },
  '.status_pending:before': {
    fontFamily: iconFontFamily,
    content: '"\\E917"',
    fontSize: 13,
  },
  '.status_warning:before': {
    fontFamily: iconFontFamily,
    content: '"\\E7BA"',
    color: '#FF9900',
  },
  '.status_success:before': {
    fontFamily: iconFontFamily,
    content: '"\\E930"',
    color: palette.green,
  },
  '.statusPending_icon:before': {
    fontFamily: iconFontFamily,
    content: '"\\E7BA"',
    color: palette.orange,
  },
  '.statusProcessing_icon:before': {
    fontFamily: iconFontFamily,
    content: '"\\EA03"',
  },
  '.icon-arrowdown-normal:before': {
    fontFamily: iconFontFamily,
    content: '"\\E70D"',
  },
  '.icon-arrowdown-hover:before': {
    fontFamily: iconFontFamily,
    content: '"\\E70D"',
  },
  '.glyphicon-arrow-left': {
    fontFamily: iconFontFamily,
    color: palette.themePrimary,
  },
  '.glyphicon-arrow-left:before': {
    content: '"\\E72B"',
  },
  '.contextual-filter-menu .ms-ContextualMenu-item button.ms-ContextualMenu-link div i.ms-ContextualMenu-submenuIcon': {
    color: palette.neutralPrimary,
  },
});
